/**
 * TextField Component
 * Encapsulated TextField with consistent styling
 */

import React from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const TextField: React.FC<TextFieldProps> = ({
  sx,
  ...props
}) => {
  const theme = useTheme();

  const defaultStyles = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.customColors.searchBackground : 'transparent',
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
      // Fix for Chrome/Safari autofill blue background
      '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
        // Use transition to prevent browser from applying the default yellow/blue background
        transition: 'background-color 99999999s ease-in-out 0s',
        // Text color fix
        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        caretColor: theme.palette.text.primary,
        // Ensure no additional shadow overlay is applied
        WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
        borderRadius: 'inherit',
      },
    },
    '& .MuiInputLabel-asterisk': {
      color: theme.palette.error.main,
    },
  };

  return (
    <MuiTextField
      sx={{
        ...defaultStyles,
        ...sx,
      }}
      {...props}
    />
  );
};

export type { TextFieldProps };

